<form [formGroup]="form" class="grid">
  @for (field of fields; track field) {
    @switch (field.type) {
      @case ('ADDITIONS_INDEX') {
        <app-select [formControlName]="field.name">
          <app-select-label>
            {{ field.description }}
            @if (field.forWrite) {
              <span>{{ 'CONTROLS.read_only' | translate }}</span>
            }
            @if (!field.forWrite) {
              <span>{{ 'CONTROLS.write_only' | translate }}</span>
            }
          </app-select-label>
          @if (!field.required) {
            <mat-option [value]="null">{{ 'CONTROLS.not_specified' | translate }}</mat-option>
          }
          @for (additionalField of additionalFields$ | async; track additionalField) {
            <mat-option [value]="additionalField.name">
              {{ additionalField | label:'additional-fields' | async }}
            </mat-option>
          }
        </app-select>
      }
      @case ('ENTITY') {
        @switch (field.entity) {
          @case ('good') {
            <app-select [formControlName]="field.name">
              <app-select-label>{{ field.description }}</app-select-label>
              @for (good of goods$ | async; track good) {
                <mat-option [value]="good.id">{{ good.name }}</mat-option>
              }
            </app-select>
          }
          @case ('sender') {
            <app-select [formControlName]="field.name">
              <app-select-label>{{ field.description }}</app-select-label>
              @for (sender of senders$ | async; track sender) {
                <mat-option [value]="sender.id">{{ sender.name }}</mat-option>
              }
            </app-select>
          }
          @case ('status') {
            <app-select [formControlName]="field.name">
              <app-select-label>{{ field.description }}</app-select-label>
              @for (status of statuses$ | async; track status) {
                <mat-option [value]="status.id">{{ status.name }}</mat-option>
              }
            </app-select>
          }
          @case ('storehouse') {
            <app-select [formControlName]="field.name">
              <app-select-label>{{ field.description }}</app-select-label>
              @for (storehouse of storehouses$ | async; track storehouse) {
                <mat-option [value]="storehouse.id">
                  {{ storehouse.name }}
                </mat-option>
              }
            </app-select>
          }
        }
      }
      @case ('FILE') {
        <app-file-upload [formControlName]="field.name"
          [description]="field.description"
          [selectedExtension]="field.extension">
        </app-file-upload>
      }
      @case ('NUMERIC') {
        <mat-form-field class="grid">
          <mat-label>{{ field.description }}</mat-label>
          <input [formControlName]="field.name" matInput type="number">
        </mat-form-field>
      }
      @case ('SELECTABLE') {
        <app-select [formControlName]="field.name">
          <app-select-label>{{ field.description }}</app-select-label>
          @if (!field.required) {
            <mat-option [value]="null">{{ 'CONTROLS.not_specified' | translate }}</mat-option>
          }
          @for (value of field.values; track value) {
            <mat-option [value]="value.value">
              {{ value.description }}
            </mat-option>
          }
        </app-select>
      }
      @case ('SHORT_TEXT') {
        <mat-form-field class="grid">
          <mat-label>{{ field.description }}</mat-label>
          <input [formControlName]="field.name" matInput>
        </mat-form-field>
      }
      @case ('SWITCHABLE') {
        <mat-checkbox [formControlName]="field.name">{{ field.description }}</mat-checkbox>
      }
      @case ('RULE_SET') {
        <div class="grid">
          <span class="subtitle">{{ field.description }}</span>
          <app-filter-with-popover [formControlName]="field.name"
            [orderFieldMap]="orderFieldMap$ | async">
          </app-filter-with-popover>
          <app-rule-view [rule]="form.controls[field.name].value"></app-rule-view>
        </div>
      }
      <!--  Для type='SUBSET' снова вызываем app-dynamic-form только в том случае, -->
      <!--  если это не родительский компонент (т.е. не корень этого дерева),      -->
      <!--  для того чтобы в форме видели только превью,                           -->
      <!--  а в самом диалоговом окне уже имели формы для редактирования           -->
      @case ('SUBSET') {
        <ng-container [formArrayName]="field.name" class="grid">
          <div class="add">
            @if (!isParent) {
              <button
                (click)="addSubsetItem(field.name, field.schema)"
                color="primary"
                mat-button>
                <mat-label>{{ field.description }}</mat-label>
                <mat-icon style="margin-left: 5px">add</mat-icon>
              </button>
            }
            @if (isParent) {
              <button
                (click)="openSubsetDialog(field)"
                color="primary"
                mat-button>
                <mat-label>{{ field.description }}</mat-label>
                <mat-icon style="margin-left: 5px">add</mat-icon>
              </button>
            }
          </div>
          @if (!isParent) {
            @for (formGroup of getSubsetForms(field.name); track formGroup) {
              <app-dynamic-form
                class="subset"
                [formGroup]="formGroup"
                [fields]="field.schema">
              </app-dynamic-form>
            }
          }
          @if (isParent) {
            <div class="subsets-list">
              @for (subsets of getSubsets(field.schema, form.controls[field.name].value); track trackByIndex(i, subsets); let i = $index) {
                <div class="subset-view"
                  >
                  <button (click)="openEditSubsetDialog(field, i)" color="primary" mat-icon-button>
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button (click)="removeSubsetItem(field.name, i)" color="warn" mat-icon-button>
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                  @for (subset of subsets; track trackByName($index, subset)) {
                    <app-subset-view [subset]="subset"
                      [goods]="goods$ | async"
                      [senders]="senders$ | async"
                      [statuses]="statuses$ | async"
                      [storehouses]="storehouses$ | async">
                    </app-subset-view>
                  }
                </div>
              }
            </div>
          }
        </ng-container>
      }
      @case ('GROUP') {
        <div style="text-align: center">{{ field.description }}</div>
        <div class="group">
          <div>{{ 'CONTROLS.group_named' | translate: { name: field.name } }}</div>
          <div class="controls">
            <app-dynamic-form [formGroup]="form.controls[field.name]" [fields]="field.schema">
            </app-dynamic-form>
          </div>
        </div>
      }
    }
  }
</form>
